import React, { useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { Loader } from '../../../../Components'
import userService from '../../../../Services/userService'
//
import { Ssce, PersonalInformationSlip, AptitudeTest, ProfilePhotoPreview, RegisterFooter, RegisterHeader } from '../../Components/Index'
import './ConfirmationSlip.scss'

const ConfirmationSlip = () => {
  const { refid } = useParams<any>()
  const [values, setValues] = useState({})

  const [loader, setLoader] = useState(false)
  const [disableStatus, setDisableStatus] = useState(false)

  async function getData () {
    setLoader(true)
    setDisableStatus(false)
    await userService.getData(refid).then((res:any) => {
      console.log(res.data())
      setValues(res.data())
      setLoader(false)
      setDisableStatus(true)
    }, error => {
      setLoader(false)
      setDisableStatus(false)
      toast.error(error, { duration: 20000, className: 'bg-danger text-white' })
    })
  }
  useEffect(() => {
    getData()
  }, [refid])

  return (
    <div className="confirmation bg-light">
      <div className="register-main">
        <RegisterHeader></RegisterHeader>
          <div className="container">
              <div className="register-inner">
                  <div className="spacer"></div>

                  {Object.keys(values).length !== 0 && values !== undefined && (<>
                    <ProfilePhotoPreview value={values} disable={disableStatus}/>
                    <PersonalInformationSlip value={values} disable={disableStatus}/>
                    <Ssce value={values} disable={disableStatus}/>
                    <AptitudeTest value={values} disable={disableStatus}/>
                  </>)}
                  <div className="card">
                    <div className="card-body text-center">
                    <button onClick={() => window.print()} className="btn btn-dark"> Print Slip </button>
                    </div>
                  </div>
              </div>
        <Toast/>
      </div>
            <RegisterFooter></RegisterFooter>
    </div>

    <Loader show={loader}/>
  </div>
  )
}

export default ConfirmationSlip
